<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="12">
          <title-text />
        </b-col>
        <b-col
          cols="12"
        >
          <content-text />
        </b-col>
      </b-row>
    </b-card>
    <seo-component data-store="about/dataItem" />
  </div>
</template>
<script>
import TitleText from '@/views/Admin/About/elements/TitleText.vue'
import ContentText from '@/views/Admin/About/elements/ContentText.vue'
import { BCard, BCol, BRow } from 'bootstrap-vue'
import SeoComponent from '@/layouts/components/common/SeoComponent.vue'

export default {
  name: 'ItemForm',
  components: {
    SeoComponent,
    BCard,
    BRow,
    BCol,

    ContentText,
    TitleText,
  },
}
</script>
